import React from 'react'
import { cn } from '@/lib/utils'
import {
  buildNiceTicks,
  DEFAULT_CHART_MARGIN,
  valueToPlotTop,
} from './chart-axis-utils'

const StickyYAxisLabels = ({
  yMin,
  yMax,
  chartHeight = 600,
  tickCount = 8,
  ticks: ticksProp,
  tickMode = 'percent',
  tickFormatter,
  labelOffset = 0,
  showPercentage = false,
  className,
  leftPosition = 0,
  margin = DEFAULT_CHART_MARGIN,
}) => {
  const ticks =
    ticksProp ?? buildNiceTicks(yMin, yMax, tickCount, { mode: tickMode })

  return (
    <div
      className={cn('absolute top-0 h-full pointer-events-none', className)}
      style={{ height: chartHeight, width: 'auto', left: leftPosition }}
    >
      {ticks.map((tickValue, index) => {
        const topPosition = valueToPlotTop(
          tickValue,
          yMin,
          yMax,
          chartHeight,
          margin,
        )

        return (
          <div
            key={index}
            className="absolute text-xs fill-muted-foreground"
            style={{
              top: `${topPosition}px`,
              left: labelOffset,
              transform: 'translateY(-50%)',
              textAlign: 'right',
              whiteSpace: 'nowrap',
              pointerEvents: 'auto',
            }}
          >
            {tickFormatter
              ? tickFormatter(tickValue)
              : showPercentage
                ? `${tickValue.toFixed(0)}%`
                : tickValue}
          </div>
        )
      })}
    </div>
  )
}

export default StickyYAxisLabels
